import { useCallback, useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { WEBBACK_V2_API } from "@constants"
import { useToast } from "@hooks"
import { commonFiltersValue, isLoadingCommonFilters, userData } from "@signals"
import { adminProductReviewRawTableData, AdminProductReviewRetailerSelected } from "../@signals"


export default function useAdminProductReviewSubmits() {
	const { showToast } = useToast()

	const adminProductReviewHeaderSummary = useSignal([])

	useEffect(() => {
		if (isLoadingCommonFilters.value) batch(() => {
			adminProductReviewRawTableData.value = []
			AdminProductReviewRetailerSelected.value = []
			adminProductReviewHeaderSummary.value = []
			return postSubmit(`${WEBBACK_V2_API}/admin/product-review-new/raw-data`, {
				...commonFiltersValue.value,
				customerID: userData.value.id_customer,
				sku: [],
				skuGroup: null
			}).then(({ table, summary }) => {
				AdminProductReviewRetailerSelected.value = commonFiltersValue.peek().retailer
				if (!!table.length) {
					adminProductReviewRawTableData.value = table
					adminProductReviewHeaderSummary.value = summary
				}
			}).catch(() => showToast.error()
			).finally(() => isLoadingCommonFilters.value = false)
		})
	}, [isLoadingCommonFilters.value])
	
	return {
		adminProductReviewHeaderSummary: adminProductReviewHeaderSummary.value,
	}
}